import React from 'react';
import { MessageCircle } from 'lucide-react';

interface ChatButtonProps {
  onClick: () => void;
  unreadCount?: number;
  isOpen?: boolean;
}

/**
 * Facebook-style chat button that appears in the top-right of the dashboard.
 * Shows unread message count as a badge.
 */
const ChatButton: React.FC<ChatButtonProps> = ({ onClick, unreadCount = 0, isOpen = false }) => {
  return (
    <button
      onClick={onClick}
      className={`
        relative flex items-center justify-center
        w-10 h-10 rounded-full
        transition-all duration-200 ease-in-out
        focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2
        dark:focus:ring-offset-dark-bg-secondary
        ${isOpen 
          ? 'bg-blue-700 text-white shadow-lg' 
          : 'bg-blue-600 hover:bg-blue-700 text-white shadow-md hover:shadow-lg'
        }
      `}
      aria-label={`Team Chat${unreadCount > 0 ? ` - ${unreadCount} unread messages` : ''}`}
      title="Team Chat"
    >
      <MessageCircle className="w-5 h-5" />
      
      {/* Unread badge */}
      {unreadCount > 0 && (
        <span
          className="
            absolute -top-1 -right-1
            flex items-center justify-center
            min-w-[18px] h-[18px] px-1
            text-xs font-bold text-white
            bg-red-500 rounded-full
            shadow-sm
            animate-pulse
          "
        >
          {unreadCount > 99 ? '99+' : unreadCount}
        </span>
      )}
    </button>
  );
};

export default ChatButton;

